import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'
import moment from 'moment'
import Numeral from 'numeral'
import { makePropSelector, db, doc, currentDate } from './common'
import { leases, properties, applications, listings } from './entities'
import { leasesByPropertyID, termsByLeaseID, listingsByPropertyID, applicationsByPropertyAlias, repairsByPropertyID, transactionsByPropertyID } from './index'
import { checkTransactions } from './property'
import { getTimezoneDate } from 'utils/date'

let eventsInContract = {
	'Move in': true,
	'Rent collected': true,
	'Late payment': true,
	'No payment': true,
	'Partial payment': true,
	'Move out': true,
	'Contract break': true,
	'Contract renewal': true,
	'Task': true,
	'Repair': true,
	'Cleaning and maintenance': true
}

let categories = (history) => {
	let newHistory = []
	let otherEvents = []
	let contractedEvent = false
	let divider = false
	R.forEach(event => {
		if (event.type == 'Contract') {
			if (!contractedEvent) {
				if (divider === true) {
					newHistory.push({ type: "Divider" })
				}
				newHistory.push({ ...event, contractedEvent: true })
				divider = false
			} else {
				otherEvents.push({ ...event, contractedEvent: false })
			}
			contractedEvent = true
		}
		let inContract = event && (eventsInContract[event.type] || eventsInContract[event.category])
		if (inContract || !contractedEvent) {
			if (inContract) {
				if (divider === true){
					newHistory.push({ type: "Divider" })
					divider = false
				}
				if (event.type == 'Move out' && moment().diff(moment(event.date), 'days') > -event.notificationPeriod) {
					newHistory.push({...event, contractedEvent})
				} else if (event.type != 'Move out') {
					newHistory.push({ ...event, contractedEvent })
				}
			} else {
				if (divider === 'moveout') {
					newHistory.push({ type: "Divider" })
				}
				divider = true
				newHistory.push({...event, contractedEvent: false })
			}
		} else {
			if (event.type != 'Contract') {
				otherEvents.push({ ...event, contractedEvent: false })
			}
		}
		if (event.type == 'Move out') {
			if (otherEvents.length) {
				newHistory.push({ type: "Divider" })
			} else {
				divider = 'moveout'
			}
			contractedEvent = false
			otherEvents.forEach(ev => {
				if (ev.type == 'Contract') {
					contractedEvent = true
					divider = 'Contract'
					newHistory.push({ type: "Divider" })
			  	}
				newHistory.push({ ...ev, contractedEvent })
			})
			if (otherEvents.length > 0 && divider != 'Contract') {
				divider = true
			}
			otherEvents.length = 0
		}
	})(history || [])
	return R.reverse(newHistory)
}

let applicationStatusMeta = {
	'new'     : { name: '' }
  , 'accepted': { name: 'Accepted' }
  , 'rejected': { name: 'Rejected' }
  , undefined : { name: '' }
}

export let propertyEventsEx = createSelector(
	[properties, listingsByPropertyID, applicationsByPropertyAlias, leasesByPropertyID, termsByLeaseID, currentDate, repairsByPropertyID, checkTransactions]
  , (properties, listingsByPropertyID, applicationsByPropertyAlias, leasesByPropertyID, termsByLeaseID, currentDate, repairsByPropertyID, checkTransactions) => {
		return R.map(property => {
			let propertyID = property._id
			let propertyAlias = property && property.alias
			let listings = listingsByPropertyID[propertyID] || []
			let applications = applicationsByPropertyAlias[propertyAlias] || []
			let leases = leasesByPropertyID[propertyID] || []
			let repairs = repairsByPropertyID[propertyID] || []

			listings = listings.map(x => {
				return {
					type: 'Listing'
				  , date: x.dateFrom
				  , description: '$'+(Numeral(x.rent || property.rent).format('0,00.') || '0')
				  , priority: 1
				  , url: '/manager/listing/' + x._id
				}
			})

			applications = applications.map(x => {
				let statusName = applicationStatusMeta[x.status].name
				return ({
					type: 'Application ' + statusName
				  , date: x.date || "2017-01-01"
				  , description: statusName
				  , priority: 2
				  , url: '/manager/application/' + x._id
				})
			})

			let contracts = leases.map(x => {
				return ({
					type: 'Contract' // blue
				  , date: x.date
				  , description: '$' + Numeral(x.rent || property.rent).format('0,00.')
				  , priority: 3
				  , url: '/manager/lease/' + x._id
				})
			})

			let moveins = leases.map(x => {
				return {
					type: 'Move in' // green
				  , date: x.dateFrom
				  , description: ''
				  , priority: 5
				  , url: '/manager/lease/' + x._id
				}
			})

			let contractBreaks = leases.map(x => {
				if (!x.breakDate) return
				return {
					type: 'Contract break' // blue
				  , date: x.breakDate
				  , description: ""
				  , priority: 4
				  , url: '/manager/lease/' + x._id
				}
			})

			let moveouts = leases.map(x => {
				if (!x.breakDateTill) {

					let terms = termsByLeaseID[x._id] || []
					terms = R.sortBy(R.prop('dateTill'))(terms)
					let n = terms && terms.length
					if (n) x = terms[n-1]
				}
				return {
					type:'Move out'
				  , date: x.breakDateTill || x.dateTill
				  , description: ''
				  , priority: 4
				  , url: '/manager/lease/' + (x.parentID || x._id)
				  , notificationPeriod: x.notificationPeriod || 60
				}
			})

			let renewals = R.chain(lease => {
				let terms = termsByLeaseID[lease._id] || []
				terms = R.sortBy(R.prop('dateTill'))(terms)
				return terms.map(x => ({
					type:'Contract renewal' // blue
				  , date: x.date || x.dateFrom
				  , description: ''
				  , priority: 4
				  , url: '/manager/lease/' + x.parentID
				}))
			})(leases)

			repairs = repairs.map(x => {
				return {
					type: 'Task'
				  , date: x.date
				  , description: ''
				  , priority: 5
				  , url: '/manager/project/' + x.projectID
				  , name: x.projectName
				}
			})

			let transactionsUnPaid = R.map(x=>{
				if (!x.partialPayment) {
					return({
						type:'No payment'
					  , date: x.dueDate || x.date
					  , description: '$' + Numeral(-x.balance).format('0,00.') || ""
					  , priority: 8
					  , url: '/manager/transaction/' + x._id
					})
				} else {
					return({
						type:'Partial payment'//partial
					  , date: x.dueDate || x.date
					  , description: '$' + (Numeral(x.amount + x.balance)).format('0,00.') || ""
					  , priority: 8
					  , url: '/manager/transaction/' + x._id
					})
				}
			}, checkTransactions[propertyID] && checkTransactions[propertyID].unPaid || []) || []

		  	let transactionsLatePaid = R.map(x=>{
			  	let days = Numeral((getTimezoneDate(x.lastPayment).getTime()-getTimezoneDate(x.dueDate).getTime()) / (1000*60*60*24)).format('0')
			  	return({
					type:'Late payment'
				  , name: 'Late payment ('+ days + (days==1?" day" : " days")+')'
				  , date: x.lastPayment || x.dueDate || x.date
				  , description: '$'+Numeral(+x.amount).format('0,00.')
				  , priority: 8
				  , url: '/manager/transaction/' + x._id
				})
			}, checkTransactions[propertyID] && checkTransactions[propertyID].latePaid || []) || []

			let transactionsPaid = R.map(x=>{
				let days = Numeral((getTimezoneDate(x.lastPayment).getTime()-getTimezoneDate(x.dueDate).getTime()) / (1000*60*60*24)).format('0')
				return ({
					type: 'Rent collected'
				  , date: x.lastPayment || x.dueDate || x.date
				  , description: '$'+(Numeral(x.amount).format('0,00.'))
				  , priority: 8
				  , url: '/manager/transaction/' + x._id
		  		})
		  	}, checkTransactions[propertyID] && checkTransactions[propertyID].paid || []) || []

			let events = R.unnest([
				listings
			  , applications
			  , contracts
			  , moveins
			  , moveouts
			  , contractBreaks
			  , renewals
			  , repairs
			  , transactionsUnPaid
			  , transactionsLatePaid
			  , transactionsPaid
			])

			let dates = x => {
				let date = moment(x.date)
				return {
					...x
				  , date: date.format('DD MMM YY')
				  , timestamp: date.valueOf()
				}
			}

			let sort = R.sortWith([
				R.ascend(R.prop('timestamp'))
			  , R.ascend(R.prop('priority'))
			])

			let occupiedStatus=false
			let contractedStatus=false
			let forRentStatus=false
			let statusOfProperty = {
					occupied: false
			  , forRent: false
			  , contracted: false
			}

			let tenantIDs ={}

			let statusEx = (x) => {
				let stOccupied=occupiedStatus
				if (!statusOfProperty.occupied && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					statusOfProperty.occupied = occupiedStatus ? "Occupied" : "Not Occupied"
				}
				if (!statusOfProperty.contracted && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					statusOfProperty.contracted = contractedStatus ? "Contracted" : "Not Contracted"
				}
				if ((x.type =='Move in' || x.type =='Move out') && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') <= moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					delete tenantIDs[(x.parentID && leases[x.parentID] && leases[x.parentID].tenantID) || x.tenantID]
					if (!R.values(tenantIDs).length) contractedStatus=false
					if (x.type =='Move in') {
						occupiedStatus   = true
						contractedStatus = false
					}
					if (x.type =='Move out' && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') < moment(new Date(currentDate)).format('YYYY-MM-DD')) occupiedStatus=false
				}
				if (x.type =='Contract') {
					contractedStatus = true
					tenantIDs[(x.parentID && leases[x.parentID] && leases[x.parentID].tenantID) || x.tenantID] = true
					forRentStatus = false
				}

				if (x.type =='Listing' && (moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') <= moment(new Date(currentDate)).format('YYYY-MM-DD')) && (!x.dateTill || (moment(getTimezoneDate(x.dateTill)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')))) {
					forRentStatus = true
				}
				return {...x, status: stOccupied}
			}

			let checkOccupiedStatus =()=>{
				if (!statusOfProperty.occupied && events && events.length)
					statusOfProperty.occupied = occupiedStatus ? "Occupied" : "Not Occupied"
				if (!statusOfProperty.contracted && events && events.length)
					statusOfProperty.contracted = contractedStatus ? "Contracted" : "Not Contracted"
				if (!statusOfProperty.forRent && events && events.length)
					statusOfProperty.forRent = forRentStatus ? "For Rent" : "Not for Rent"
				statusOfProperty.paid = !(checkTransactions[propertyID] && checkTransactions[propertyID].unPaid || []).length

				return statusOfProperty
			}

			return {
				history: R.pipe(
					R.filter(x => x)
				  , R.map(dates)
				  , sort
				  , R.map(statusEx)
				  , categories
				)(events)
			  , status: checkOccupiedStatus()
			}
		}, properties)
	}
  , 'propertyEventsEx'
)








export let propertyLLEventsEx = createSelector(
	[properties, listingsByPropertyID, applicationsByPropertyAlias, leasesByPropertyID, termsByLeaseID, currentDate, transactionsByPropertyID, repairsByPropertyID, checkTransactions]
  , (properties, listingsByPropertyID, applicationsByPropertyAlias, leasesByPropertyID, termsByLeaseID, currentDate, transactionsByPropertyID, repairsByPropertyID, checkTransactions) => {
		return R.map(property => {
			let propertyID = property._id
			let propertyAlias = property && property.alias
			let listings = listingsByPropertyID[propertyID] || []
			let applications = applicationsByPropertyAlias[propertyAlias] || []
			let leases = leasesByPropertyID[propertyID] || []
			let repairs = repairsByPropertyID[propertyID] || []
			let bills = transactionsByPropertyID[propertyID] || []

			listings = listings.map(x => {
				return {
					type: 'Listing'
				  , date: x.dateFrom
				  , description: '$'+(Numeral(x.rent || property.rent).format('0,00.') || '0')
				  , priority: 1
				  , url: '/landlord/listing/' + x._id
				}
			})

			applications = applications.map(x => {
				let statusName = applicationStatusMeta[x.status].name
				return ({
					type: 'Application ' + statusName
				  , date: x.date || "2017-01-01"
				  , description: statusName
				  , priority: 2
				  , url: '/landlord/application/' + x._id
				})
			})

			let contracts = leases.map(x => {
				return ({
					type: 'Contract' // blue
				  , date: x.date
				  , description: '$' + Numeral(x.rent || property.rent).format('0,00.')
				  , priority: 3
				  , url: '/landlord/lease/' + x._id
				})
			})

			let moveins = leases.map(x => {
				return {
					type: 'Move in' // green
				  , date: x.dateFrom
				  , description: ''
				  , priority: 5
				  , url: '/landlord/lease/' + x._id
				}
			})

			let contractBreaks = leases.map(x => {
				if (!x.breakDate) return
				return {
					type: 'Contract break' // blue
				  , date: x.breakDate
				  , description: ""
				  , priority: 4
				  , url: '/landlord/lease/' + x._id
				}
			})

			let moveouts = leases.map(x => {
				if (!x.breakDateTill) {

					let terms = termsByLeaseID[x._id] || []
					terms = R.sortBy(R.prop('dateTill'))(terms)
					let n = terms && terms.length
					if (n) x = terms[n-1]
				}
				return {
					type:'Move out'
				  , date: x.breakDateTill || x.dateTill
				  , description: ''
				  , priority: 4
				  , url: '/landlord/lease/' + (x.parentID || x._id)
				  , notificationPeriod: x.notificationPeriod || 60
				}
			})

			let renewals = R.chain(lease => {
				let terms = termsByLeaseID[lease._id] || []
				terms = R.sortBy(R.prop('dateTill'))(terms)
				return terms.map(x => ({
					type:'Contract renewal' // blue
				  , date: x.date || x.dateFrom
				  , description: ''
				  , priority: 4
				  , url: '/landlord/lease/' + x.parentID
				}))
			})(leases)

			repairs = repairs.map(x => {
				return {
					type: 'Task'
				  , date: x.date
				  , description: ''
				  , priority: 5
				  , url: '/landlord/project/' + x.projectID
				  , name: x.projectName
				}
			})

			let transactionsUnPaid = R.map(x=>{
				if (!x.partialPayment) {
					return({
						type:'No payment'
					  , date: x.dueDate || x.date
					  , description: '$' + Numeral(-x.balance).format('0,00.') || ""
					  , priority: 8
					  , url: '/landlord/transaction/' + x._id
					})
				} else {
					return({
						type:'Partial payment'//partial
					  , date: x.dueDate || x.date
					  , description: '$' + (Numeral(x.amount + x.balance)).format('0,00.') || ""
					  , priority: 8
					  , url: '/landlord/transaction/' + x._id
					})
				}
			}, checkTransactions[propertyID] && checkTransactions[propertyID].unPaid || []) || []

		  	let transactionsLatePaid = R.map(x=>{
			  	let days = Numeral((getTimezoneDate(x.lastPayment).getTime()-getTimezoneDate(x.dueDate).getTime()) / (1000*60*60*24)).format('0')
			  	return({
					type:'Late payment'
				  , name: 'Late payment ('+ days + (days==1?" day" : " days")+')'
				  , date: x.lastPayment || x.dueDate || x.date
				  , description: '$'+Numeral(+x.amount).format('0,00.')
				  , priority: 8
				  , url: '/landlord/transaction/' + x._id
				})
			}, checkTransactions[propertyID] && checkTransactions[propertyID].latePaid || []) || []

			let transactionsPaid = R.map(x=>{
				let days = Numeral((getTimezoneDate(x.lastPayment).getTime()-getTimezoneDate(x.dueDate).getTime()) / (1000*60*60*24)).format('0')
				return ({
					type: 'Rent collected'
				  , date: x.lastPayment || x.dueDate || x.date
				  , description: '$'+(Numeral(x.amount).format('0,00.'))
				  , priority: 8
				  , url: '/landlord/transaction/' + x._id
		  		})
		  	}, checkTransactions[propertyID] && checkTransactions[propertyID].paid || []) || []
















			let expenses=[]
			R.forEach(bill => {
					if (bill.type != 'transaction/bill') return;
					R.forEach(expense => {
							let type;
							let category;
							if (expense.category.includes('Repair')) {category = 'Repair'; type = expense.memo || "Repair"}
							if (expense.category.includes('Cleaning and maintenance')) {category = 'Cleaning and maintenance'; type = expense.memo || 'Cleaning and maintenance'}

							if(type){
									expenses.push({...bill, expense, type, category})
							}
					})(bill.expenses)
			})(bills)


			bills = expenses.map(x => {
				return {
					type: x.category
					, date: x.date
					, description: '$' + Numeral(x.expense.amount).format('0,00.') || ""
					, priority: 8
					, url: '/landlord/transaction/' + x._id
				}
			})





			let events = R.unnest([
				listings
			  , applications
			  , contracts
			  , moveins
			  , moveouts
			  , contractBreaks
			  , renewals
			  , repairs
				, bills
			  , transactionsUnPaid
			  , transactionsLatePaid
			  , transactionsPaid
			])

			let dates = x => {
				let date = moment(x.date)
				return {
					...x
				  , date: date.format('DD MMM YY')
				  , timestamp: date.valueOf()
				}
			}

			let sort = R.sortWith([
				R.ascend(R.prop('timestamp'))
			  , R.ascend(R.prop('priority'))
			])

			let occupiedStatus=false
			let contractedStatus=false
			let forRentStatus=false
			let statusOfProperty = {
					occupied: false
			  , forRent: false
			  , contracted: false
			}

			let tenantIDs ={}

			let statusEx = (x) => {
				let stOccupied=occupiedStatus
				if (!statusOfProperty.occupied && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					statusOfProperty.occupied = occupiedStatus ? "Occupied" : "Not Occupied"
				}
				if (!statusOfProperty.contracted && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					statusOfProperty.contracted = contractedStatus ? "Contracted" : "Not Contracted"
				}
				if ((x.type =='Move in' || x.type =='Move out') && x.date && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') <= moment(new Date(currentDate)).format('YYYY-MM-DD')) {
					delete tenantIDs[(x.parentID && leases[x.parentID] && leases[x.parentID].tenantID) || x.tenantID]
					if (!R.values(tenantIDs).length) contractedStatus=false
					if (x.type =='Move in') {
						occupiedStatus   = true
						contractedStatus = false
					}
					if (x.type =='Move out' && moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') < moment(new Date(currentDate)).format('YYYY-MM-DD')) occupiedStatus=false
				}
				if (x.type =='Contract') {
					contractedStatus = true
					tenantIDs[(x.parentID && leases[x.parentID] && leases[x.parentID].tenantID) || x.tenantID] = true
					forRentStatus = false
				}

				if (x.type =='Listing' && (moment(getTimezoneDate(x.date)).format('YYYY-MM-DD') <= moment(new Date(currentDate)).format('YYYY-MM-DD')) && (!x.dateTill || (moment(getTimezoneDate(x.dateTill)).format('YYYY-MM-DD') > moment(new Date(currentDate)).format('YYYY-MM-DD')))) {
					forRentStatus = true
				}
				return {...x, status: stOccupied}
			}

			let checkOccupiedStatus =()=>{
				if (!statusOfProperty.occupied && events && events.length)
					statusOfProperty.occupied = occupiedStatus ? "Occupied" : "Not Occupied"
				if (!statusOfProperty.contracted && events && events.length)
					statusOfProperty.contracted = contractedStatus ? "Contracted" : "Not Contracted"
				if (!statusOfProperty.forRent && events && events.length)
					statusOfProperty.forRent = forRentStatus ? "For Rent" : "Not for Rent"
				statusOfProperty.paid = !(checkTransactions[propertyID] && checkTransactions[propertyID].unPaid || []).length

				return statusOfProperty
			}

			return {
				history: R.pipe(
					R.filter(x => x)
				  , R.map(dates)
				  , sort
				  , R.map(statusEx)
				  , categories
				)(events)
			  , status: checkOccupiedStatus()
			}
		}, properties)
	}
  , 'propertyLLEventsEx'
)














// TODO remove eventsByPropertyID
export let eventsByPropertyID = createSelector(
	[propertyLLEventsEx, makePropSelector('propertyID')]
  , (properties, propertyID) => {
		return properties[propertyID]
	}
)



// WEBPACK FOOTER //
// ./src/selectors/events.js